// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   .sly-btn — corner-bracket HUD button + .wallet-pill modifier
   Shared between the landing app's nav and the playground's
   toolbar. Tokens (--cyan, --mint, etc.) come from tokens.css.
   ============================================================ */

.sly-btn {
  appearance: none;
  background: transparent;
  border: 1px solid var(--line-bright);
  color: var(--ink);
  font-family: 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: 10.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  padding: 6px 12px;
  cursor: pointer;
  position: relative;
  transition: all 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.sly-btn::before,
.sly-btn::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  border: 1px solid var(--cyan);
}
.sly-btn::before {
  top: -1px;
  left: -1px;
  border-right: 0;
  border-bottom: 0;
}
.sly-btn::after {
  bottom: -1px;
  right: -1px;
  border-left: 0;
  border-top: 0;
}
.sly-btn:hover {
  color: var(--cyan);
  border-color: var(--cyan);
  background: rgba(var(--cyan-rgb), 0.06);
}
.sly-btn.primary {
  background: var(--cyan);
  color: var(--bg-deep);
  border-color: var(--cyan);
  font-weight: 600;
}
.sly-btn.primary::before,
.sly-btn.primary::after {
  border-color: var(--bg-deep);
}
.sly-btn.primary:hover {
  background: var(--mint);
  border-color: var(--mint);
}
.sly-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Wallet pill — custom HUD trigger replacing the Dynamic widget */
.sly-btn.wallet-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding-left: 10px;
  padding-right: 12px;
}
.wallet-pill-dot {
  width: 6px;
  height: 6px;
  background: var(--mint);
  box-shadow: 0 0 6px var(--mint);
  display: inline-block;
}
.sly-btn.wallet-pill:hover .wallet-pill-dot {
  background: var(--cyan);
  box-shadow: 0 0 6px var(--cyan);
}
.wallet-pill-addr {
  font-family: 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  letter-spacing: 0.04em;
  text-transform: none;
  font-variant-numeric: tabular-nums;
}
.net-status.mute {
  color: var(--ink-mute);
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/styles/sly-btn.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB,wEAAwE;EACxE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["/* ============================================================\n   .sly-btn — corner-bracket HUD button + .wallet-pill modifier\n   Shared between the landing app's nav and the playground's\n   toolbar. Tokens (--cyan, --mint, etc.) come from tokens.css.\n   ============================================================ */\n\n.sly-btn {\n  appearance: none;\n  background: transparent;\n  border: 1px solid var(--line-bright);\n  color: var(--ink);\n  font-family: 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace;\n  font-size: 10.5px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  padding: 6px 12px;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.15s;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.sly-btn::before,\n.sly-btn::after {\n  content: '';\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border: 1px solid var(--cyan);\n}\n.sly-btn::before {\n  top: -1px;\n  left: -1px;\n  border-right: 0;\n  border-bottom: 0;\n}\n.sly-btn::after {\n  bottom: -1px;\n  right: -1px;\n  border-left: 0;\n  border-top: 0;\n}\n.sly-btn:hover {\n  color: var(--cyan);\n  border-color: var(--cyan);\n  background: rgba(var(--cyan-rgb), 0.06);\n}\n.sly-btn.primary {\n  background: var(--cyan);\n  color: var(--bg-deep);\n  border-color: var(--cyan);\n  font-weight: 600;\n}\n.sly-btn.primary::before,\n.sly-btn.primary::after {\n  border-color: var(--bg-deep);\n}\n.sly-btn.primary:hover {\n  background: var(--mint);\n  border-color: var(--mint);\n}\n.sly-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Wallet pill — custom HUD trigger replacing the Dynamic widget */\n.sly-btn.wallet-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding-left: 10px;\n  padding-right: 12px;\n}\n.wallet-pill-dot {\n  width: 6px;\n  height: 6px;\n  background: var(--mint);\n  box-shadow: 0 0 6px var(--mint);\n  display: inline-block;\n}\n.sly-btn.wallet-pill:hover .wallet-pill-dot {\n  background: var(--cyan);\n  box-shadow: 0 0 6px var(--cyan);\n}\n.wallet-pill-addr {\n  font-family: 'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace;\n  letter-spacing: 0.04em;\n  text-transform: none;\n  font-variant-numeric: tabular-nums;\n}\n.net-status.mute {\n  color: var(--ink-mute);\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
